import {StateParams, StateService} from 'angular-ui-router';
import {IStation, IDataValue} from '../../api/api.types';
import {IStationDetails} from './edit.controller';
import {IStationApi} from '../../api/station-api.service';
import {IDataValueApi} from '../../api/data-value-api.service';

export interface IStationDetailsStateParams extends StateParams {
  stationId: string;
}

export default class StationDetailsController {
  static $inject = ['stationApi', 'dataValueApi', '$q', '$stateParams', '$state', '$mdDialog', '$translate', '$rootScope'];

  loadInProgress:boolean;
  stationDetails:IStationDetails;
  resetDisabled:boolean;
  saveDisabled:boolean;

  private station:IStation;
  private storedStationDetails:IStationDetails;

  constructor(private stationApi:IStationApi,
              private dataValueApi:IDataValueApi,
              private $q:ng.IQService,
              $stateParams:IStationDetailsStateParams,
              private $state:StateService,
              private $mdDialog: ng.material.IDialogService,
              private $translate:ng.translate.ITranslateService,
              private $rootScope: ng.IRootScopeService) {
    this.resetDisabled = true;
    this.saveDisabled = true;
    const stationId = Number.parseInt($stateParams.stationId);
    this.loadInProgress = true;
    const stationPromise = this.stationApi.getMeteoStation({stationId});
    this.$q.all([stationPromise])
        .then(([station]:[IStation]) => {
          this.station = station;
          this.$rootScope.$broadcast('STATION_LOADED', station);
          this.storedStationDetails = {
            basin: this.station.basin,
            code: this.station.siteCode,
            country: this.station.country,
            location: {
              latitude: this.station.latitude,
              longitude: this.station.longitude
            },
            name: this.station.siteName,
            region: this.station.region
          };
          this.resetDetails();
        }).finally(() => {
      this.loadInProgress = false;
    })

  }

  resetDetails() {
    this.stationDetails = this.storedStationDetails;
    this.resetDisabled = true;
    this.saveDisabled = true;
  }

  onDetailsChange(station:IStationDetails, isValid:boolean) {
    this.stationDetails = station;
    this.resetDisabled = angular
        .equals(this.storedStationDetails, this.stationDetails);
    this.saveDisabled = this.resetDisabled || !isValid;
  }

  saveChanges() {
    this.loadInProgress = true;
    this.saveDisabled = true;
    this.resetDisabled = true;
    this.stationApi.updateMeteoStation(this.station.id, {
      id: this.station.id,
      basin: this.stationDetails.basin,
      country: this.stationDetails.country,
      latitude: this.stationDetails.location.latitude,
      longitude: this.stationDetails.location.longitude,
      region: this.stationDetails.region,
      siteCode: this.stationDetails.code,
      siteName: this.stationDetails.name
    }).then(() => {
      this.storedStationDetails = this.stationDetails;
      this.$state.go('meteostation.manager');
    }).finally(() => {
      this.loadInProgress = false;
    })
  }

  delete() {
    let confirm = this.$mdDialog.confirm()
        .textContent(this.$translate.instant('DELETE_CONFIRMATION', {item: this.station.siteName}))
        .ok(this.$translate.instant('DELETE'))
        .cancel(this.$translate.instant('CANCEL'));

    this.$mdDialog.show(confirm).then(() => {
      this.stationApi.deleteMeteoStation(this.station.id)
        .then(() => {
          this.$state.go('meteostation.manager');
        })
    });
  }

}



/** WEBPACK FOOTER **
 ** ./app/meteostation/details/details.controller.ts
 **/